import { render, staticRenderFns } from "./OptimResult.vue?vue&type=template&id=b79c1356&"
import script from "./OptimResult.vue?vue&type=script&lang=js&"
export * from "./OptimResult.vue?vue&type=script&lang=js&"
import style0 from "./OptimResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports